import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-file-list-3-line text-lg text-primary-400"></i>
              </div>
              <span className="font-heading text-lg font-semibold text-background-50">Sugargoo Sheet</span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              The most complete Sugargoo Spreadsheet resource hub. Helping global shoppers discover products, compare costs, and shop smarter.
            </p>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Home</Link>
              </li>
              <li>
                <Link to="/article/what-is-sugargoo-spreadsheet" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Sugargoo Spreadsheet Guide</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-spreadsheet-beginner-tutorial" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Shopping Guide</Link>
              </li>
              <li>
                <a href="#categories" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Product Categories</a>
              </li>
              <li>
                <a href="#reviews" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Reviews</a>
              </li>
              <li>
                <a href="#shipping" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Shipping Guide</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">SEO Articles</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/sugargoo-shipping-cost-guide" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Shipping Cost Guide</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-coupon-discount-code-guide" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Coupons & Discounts</Link>
              </li>
              <li>
                <Link to="/article/is-sugargoo-legit-complete-review" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Is Sugargoo Legit?</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-warehouse-qc-guide" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Warehouse & QC Guide</Link>
              </li>
              <li>
                <Link to="/article/sugargoo-vs-pandabuy-comparison" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Sugargoo vs Pandabuy</Link>
              </li>
              <li>
                <Link to="/article/best-sugargoo-finds-2026" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">Best Finds 2026</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-background-50 mb-4 text-sm">External Resources</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">
                  Sugargoo Spreadsheet Main Site
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors cursor-pointer">
                  Buy Products Now
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} Sugargoo Sheet. All rights reserved. This is an informational resource website.
          </p>
          <p className="text-xs text-background-50/30 text-center sm:text-right">
            We do not process payments or guarantee third-party services. Users should verify sellers independently.
          </p>
        </div>
      </div>
    </footer>
  );
}